require('./input.css');
var tmpl = require('./input.ejs');
var Events = require('f.core.event');
var utils = require('../utils');


var Input = function (options) {
    this.options = options;
    this.init();
};

Input.prototype.init = function () {
    this.initDom();
    this.initEvent();
};

Input.prototype.initDom = function () {
    var div = document.createElement('div');
    div.innerHTML = tmpl();
    this.el = div.children[0];
    this.elSend = $(this.el).find('.c-button__send');
    this.elInput = $(this.el).find('.c-input__talk');
};



Input.prototype.initEvent = function () {
    var _self = this;
    $(this.elInput).on('click',function () {
        this.focus();
    });

    //已输入的字数提醒
    $(this.elInput).bind('input propertychange', function () {
        var count = this.maxLength - this.value.length;

        if(this.value.length > 0) {
            if(count > 0) {
                $(_self.elSend).addClass('canSend');
            }else {
                alert('不超过200字！')
            }
        }else {
            $(_self.elSend).removeClass('canSend');
        }
    });

    $(this.elSend).on('click', function (e) {
        e.preventDefault();
        console.log(_self.getMessage().content);
        // debugger
        if(window.ReviewCheck()) {

        } else {
            return false;
        }
        if(_self.getMessage().content.length>0){
            _self.trigger('message', _self.getMessage());
            _self.reset();
            $(this).removeClass('canSend');
            return false;
        }

    });

    $(this.elInput).on('keydown',function (e) {
        var currKey = 0;
        var e = e || window.event || arguments.callee.caller.arguments[0];
        currKey = e.keyCode || e.which || e.charCode;
        if (currKey==13) {
            $(_self.elSend).click();
        }
    });

};


Input.prototype.reset = function () {
    $(this.elInput)[0].value = '';

};

Input.prototype.getMessage = function () {

    var message = JSON.parse(JSON.stringify(this.options));
    message.content = $(this.elInput)[0].value.trim();

    return message;
};

Input.prototype.renderTo = function (parentNode) {
    parentNode.append($(this.el));
};

Input.prototype.show = function () {
    this.el.style.display = 'block';
    this.elInput.focus();
};

Input.prototype.hide = function () {
    this.el.style.display = 'none';
    this.elInput.blur();
};

Events.mixTo(Input);

module.exports = Input;


// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.compenont.barrage.pc/app/modules/input/index.js